<template>
    <div id="body-wrap">
        <LayoutHeader title="은평 생활" color="bg-blue">
            <ul slot="navigator" class="category_list">
                <li>홈</li>
                <li>은평 생활</li>
                <li>생활 지도</li>
            </ul>
        </LayoutHeader>
        <Lifemap />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LayoutHeader from "@/views/layout/LayoutHeader.vue";
import Lifemap from "@/views/lifemap/Lifemap.vue";

export default {
    name: "LifemapApp",
    computed: {
        ...mapGetters({
            facRepoList: 'getFacRepoList',
        }),
    },
    created() {
        this.$eventBus.$once(
            "DrawRegionNaverMap::completed-draw-region",
            geoJsonDrawing => {
                // 주민등록 인구 데이터 로딩
                let regPopProms = [];
                // 행정동 별 정보
                regPopProms.push(this.$store.dispatch("FETCH_HJD_INFO_LIST"));
                // 행정동 별 인구
                regPopProms.push(this.$store.dispatch("FETCH_HJD_POPULATION_LIST"));
                // 행정동 별 장애인 인구
                regPopProms.push(this.$store.dispatch('FETCH_HJD_DISABLED_POPULATION_LIST'));
                // 행정동 별 기초생활 수급자 인구
                regPopProms.push(this.$store.dispatch('FETCH_HJD_PENSIONER_POPULATION_LIST'));

                Promise.all(regPopProms)
                    .then(() => {
                        this.$eventBus.$emit('LifemapApp::loaded-reg-population-data');
                    });

                // 생활인구 데이터 로딩
                let lifePopProms = [];
                // 생활인구(내국인)
                lifePopProms.push(this.$store.dispatch('FETCH_LOCAL_LIFE_POPULATION_LIST'));
                // 생활인구(단기 체류 외국인)
                lifePopProms.push(this.$store.dispatch('FETCH_SHORT_STAY_POPULATION_LIST'));
                // 생활인구(장기 체류 외국인)
                lifePopProms.push(this.$store.dispatch('FETCH_LONG_STAY_POPULATION_LIST'));

                Promise.all(lifePopProms)
                    .then(() => {
                        this.$eventBus.$emit('LifemapApp::loaded-life-population-data');
                    });

                // 시설 카테고리 코드 목록
                this.$store.dispatch("FETCH_FAC_CATEGORY_CODE_LIST");
                // 시설 자료종류 정보 목록
                this.$store.dispatch("FETCH_FAC_REPO_LIST")
                    .then(() => {
                        let dataKdSqnos = [];
                        this.facRepoList.forEach(facRepo => {
                            dataKdSqnos.push(facRepo.dataKdSqno);
                        });
                        return this.$store.dispatch("FETCH_FAC_DATA", dataKdSqnos);
                    })
                    .then(() => {
                        this.$eventBus.$emit('LifemapApp::fac-data-loaded');
                    });
            }
        );
    },
    components: {
        LayoutHeader,
        Lifemap
    }
};
</script>
